import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ColorRing } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

import { pieEntersChartOptions } from './pieChartOptions';
import { piePeriodsChartOptions } from './piePeriodsChartOptions';

// eslint-disable-next-line import/order
import { transformDataToPiePeriodChart } from 'utils/transformDataToPiePeriodChart';
import { useGetTrapDetailPieEntriesChartData } from 'hooks/Traps/Trap/useGetTrapDetailPieEntriesChartData';
import { useGetTrapDetailPiePeriodsChartData } from 'hooks/Traps/Trap/useGetTrapDetailPiePriodsChartData';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface ChartCardProps {
  slug: string;
  type: TrapType;
}

const PieEntersChart: React.FC<ChartCardProps> = ({ slug, type }) => {
  const { data, isLoading } = useGetTrapDetailPieEntriesChartData(slug, type);
  const { data: periodsData, isLoading: periodsLoading } = useGetTrapDetailPiePeriodsChartData(slug, type);
  const { t } = useTranslation();

  // Transform periods data into time periods
  const transformedPeriodsData = transformDataToPiePeriodChart(periodsData || []);

  const chartOptions = pieEntersChartOptions(data ?? { series: [], labels: [] }, t);
  const periodsChartOptions = piePeriodsChartOptions(transformedPeriodsData, t, type === TrapType.SRST);

  if (isLoading || periodsLoading) {
    return (
      <div className="card d-flex m-0">
        <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '350px' }}>
          <ColorRing
            visible
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="card-body">
      <div className="row mt-4">
        <div className="col-xxl-6">
          {type !== TrapType.SRST && (
            <ReactApexChart options={chartOptions} series={chartOptions.series} type="donut" height={375} />
          )}
        </div>
        <div className={`${type !== TrapType.SRST ? 'col-xxl-6' : 'col-xxl-12'}`}>
          <ReactApexChart options={periodsChartOptions} series={periodsChartOptions.series} type="donut" height={375} />
        </div>
      </div>
    </div>
  );
};

export default PieEntersChart;
